import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
    <h1>Page not found.</h1>
    <Link to="/">Back to home page</Link>
  </div>
);
